import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDots = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 8.5C4.82843 8.5 5.5 9.17157 5.5 10C5.5 10.8284 4.82843 11.5 4 11.5C3.17157 11.5 2.5 10.8284 2.5 10C2.5 9.17157 3.17157 8.5 4 8.5Z",
			fill: ""
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 8.5C10.8284 8.5 11.5 9.17157 11.5 10C11.5 10.8284 10.8284 11.5 10 11.5C9.17157 11.5 8.5 10.8284 8.5 10C8.5 9.17157 9.17157 8.5 10 8.5Z",
			fill: ""
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 8.5C16.8284 8.5 17.5 9.17157 17.5 10C17.5 10.8284 16.8284 11.5 16 11.5C15.1716 11.5 14.5 10.8284 14.5 10C14.5 9.17157 15.1716 8.5 16 8.5Z",
			fill: ""
		})
	]
});
export default SvgDots;
